import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SmartLinkWidgetType } from 'fym-common/src/db/enums';
import { SerializedWidget } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../../common/types';
import { getWidgetIconByWidgetType } from '../../utils/getWidgetIconByWidgetType';
import { MediaBlockThumb } from '../../widgets/views/mediaWidget/MediaBlockThumb';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for several parts; each part uses its own slice of it */
import styles from './SMLBlockRow.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SMLBlockThumbProps {
  widget: SerializedWidget;
  isWarn: boolean;
}

/** The picture or the icon of a row (design d0, 2): the real picture of a Media block, else the type icon. */
const SMLBlockThumbComponent: React.FC<SMLBlockThumbProps> = ({ widget, isWarn }) => {
  if (widget.type === SmartLinkWidgetType.media) {
    return (
      <span className={clsx(styles.thumb, styles.thumbPicture)}>
        <MediaBlockThumb media={widget.data.media} />
      </span>
    );
  }
  const isBrand = widget.type === SmartLinkWidgetType.presave || widget.type === SmartLinkWidgetType.presaveSubscribe;
  return (
    <span className={clsx(styles.thumb, isBrand && styles.thumbBrand, isWarn && styles.thumbWarn)}>
      <FontAwesomeIcon icon={getWidgetIconByWidgetType(widget.type)} />
    </span>
  );
};

export const SMLBlockThumb = TypedMemo(SMLBlockThumbComponent);
